'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.SHEET_ORDER = exports.MUI_STYLE_PREFIX = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jss = require('jss');

var _manager = require('../styles/manager');

var _jssPresetDefault = require('jss-preset-default');

var _jssPresetDefault2 = _interopRequireDefault(_jssPresetDefault);

var _theme = require('../styles/theme');

var _theme2 = _interopRequireDefault(_theme);

var _normalizeJss = require('normalize-jss');

var _normalizeJss2 = _interopRequireDefault(_normalizeJss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var MUI_STYLE_PREFIX = exports.MUI_STYLE_PREFIX = 'Mui';

var prefixStyleList = function prefixStyleList(styles) {
  return styles.reduce(function (o, v) {
    return [].concat(_toConsumableArray(o), [v, '' + MUI_STYLE_PREFIX + v]);
  }, []);
};

var SHEET_ORDER = exports.SHEET_ORDER = prefixStyleList(['Layout', 'Grid', 'Collapse', 'Fade', 'Slide', 'Backdrop', 'Modal', 'Ripple', 'TouchRipple', 'ButtonBase', 'FormLabel', 'FormGroup', 'Text', 'Paper', 'Divider', 'Popover', 'Button', 'IconButton', 'SvgIcon', 'Icon', 'SwitchBase', 'Switch', 'Checkbox', 'Radio', 'RadioGroup', 'SwitchLabel', 'CircularProgress', 'LinearProgress', 'DialogActions', 'Dialog', 'DialogContent', 'DialogContentText', 'TabIndicator', 'Tab', 'Tabs', 'BottomNavigationButton', 'BottomNavigation', 'AppBar', 'Drawer', 'Menu', 'MenuItem', 'Avatar', 'CardContent', 'CardMedia', 'CardActions', 'CardHeader', 'Card', 'TextFieldLabel', 'TextFieldInput', 'TextField', 'Input', 'InputLabel', 'ListItem', 'SearchListItem', 'ListItemText', 'ListItemSecondaryAction', 'ListSubheader', 'List', 'SortableListItem', 'SortableDragLayer', 'AppStructure', 'BasicStructure', 'AutoComplete', 'FileField', 'FileInput', 'FilePreview', 'FormControl', 'FormActions', 'Text', 'Chip', 'InlineList', 'Table', 'TableHead', 'TableRow', 'TableCell', 'TableBody', 'TableSortLabel', 'Toolbar', 'DialogTitle', 'Badge', 'Breadcrumb', 'CommonCardHeader'], MUI_STYLE_PREFIX);

var ThemeProvider = (_temp2 = _class = function (_Component) {
  _inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ThemeProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ThemeProvider.__proto__ || Object.getPrototypeOf(ThemeProvider)).call.apply(_ref, [this].concat(args))), _this), _this.theme = undefined, _this.styleManager = undefined, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThemeProvider, [{
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        var theme = this.theme,
            styleManager = this.styleManager;

        return {
          theme: theme,
          styleManager: styleManager
        };
      }

      return getChildContext;
    }()
  }, {
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        var _ThemeProvider$create = ThemeProvider.createDefaultContext(this.props),
            theme = _ThemeProvider$create.theme,
            styleManager = _ThemeProvider$create.styleManager;

        this.theme = theme;
        this.styleManager = styleManager;

        // Normalize.css makes browsers render all elements more consistently and in line with modern standards.
        styleManager.jss.createStyleSheet(_normalizeJss2['default']).attach();
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentWillUpdate',
    value: function () {
      function componentWillUpdate(nextProps) {
        if (this.styleManager !== nextProps.styleManager) {
          var _ThemeProvider$create2 = ThemeProvider.createDefaultContext(nextProps),
              theme = _ThemeProvider$create2.theme,
              styleManager = _ThemeProvider$create2.styleManager;

          this.theme = theme;
          this.styleManager = styleManager;
        } else if (this.theme && nextProps.theme && nextProps.theme !== this.theme) {
          this.theme = nextProps.theme;
          this.styleManager.updateTheme(this.theme);
        }
      }

      return componentWillUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        return this.props.children;
      }

      return render;
    }()
  }], [{
    key: 'createDefaultContext',
    value: function () {
      function createDefaultContext() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var theme = props.theme || (0, _theme2['default'])();
        var styleManager = props.styleManager || (0, _manager.createStyleManager)({
          theme: theme,
          jss: (0, _jss.create)(Object.assign({}, (0, _jssPresetDefault2['default'])(), { insertionPoint: 'jss-theme-reactor' }))
        });

        if (!styleManager.sheetOrder) {
          styleManager.setSheetOrder(SHEET_ORDER);
        }

        return { theme: theme, styleManager: styleManager };
      }

      return createDefaultContext;
    }()
  }]);

  return ThemeProvider;
}(_react.Component), _class.propTypes = {
  children: _PropTypes2['default'].node.isRequired,
  styleManager: _PropTypes2['default'].styleManager,
  theme: _PropTypes2['default'].object
}, _class.childContextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired,
  theme: _PropTypes2['default'].object.isRequired
}, _temp2);
exports['default'] = ThemeProvider;


ThemeProvider.displayName = 'ThemeProvider';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/ThemeProvider/index.js
// module id = 1532
// module chunks = 32